export default __webpack_public_path__ + "static/media/instagram.db3a3220.svg";